import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getNotes } from "../../../redux/actions/contentPayer";
import { useNavigate, useParams } from "react-router-dom";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import EditorMenu from "./EditorMenu";
import Placeholder from "@tiptap/extension-placeholder";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import Blockquote from "@tiptap/extension-blockquote";
import "./style.css";
import { createNotes } from "../../../redux/actions/contentPayer";
import { editNote as editCurrentNote } from "../../../redux/actions/contentPayer";
import {
  EditUserNote,
  createUserNote,
  deleteUserNote,
  generateUserAiNote,
  getOtherLearnerNotes,
  getUserNotes,
  likeUserNote,
  resetUserAiNote,
} from "../../../redux/actions/notes";
import Spinner from "../../../components/Spinner";
import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEarthAmericas,
  faPenRuler,
  faPenToSquare,
  faRotateLeft,
  faShare,
  faShareAlt,
  faThumbsUp,
  faTrash,
  faTrashCan,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { Dialog, Transition } from "@headlessui/react";
import UpgradeModal from "./UpgradeModal";
import DeleteNoteModal from "./DeleteNoteModal";
import "./index.css";
import {
  editLastVisitedContent,
  editRedirectType,
} from "../../../redux/actions/userActivity";
import { LINKEDIN_REDIRECT_URI } from "../../../config/api_config";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Constants from "../../../common/constants";
import { Mixpanel } from "../../../config/Mixpanel";

export default function Notes({
  getlocalTimeStringFromSeconds,
  videoProgressTime,
  playerRef,
  getSecondsFromLocalString,
  lesson_id,
}) {
  const [userNotes, setUserNotes] = useState(null);
  const [userAiNote, setUserAiNote] = useState(null);
  const [isGeneratingNote, setIsGeneratingNote] = useState(false);
  const [userPermission, setUserPermission] = useState(false);
  const [isEditAiNote, setIsEditAiNote] = useState(false);
  const [userSelectedNote, setUserSelectedNote] = useState({ type: "custom" });
  const [isEditUserNote, setIsEditUserNote] = useState(false);
  const [isPublicNote, setIsPublicNote] = useState(true);
  const [otherLearnerNotes, setOtherLearnerNotes] = useState([]);
  const [nonEditableNote, setNonEditableNote] = useState({});
  const [openNonEditableModal, setOpenNonEditableModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    is_open: false,
    note: null,
  });
  const [hashmap, setHashmap] = useState({});
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const profile_image = useSelector(
    (store) => store?.profileDetails?.profile_image
  );
  const { course_slug, skill_slug, mskill_slug, contentId, new_user } =
    useParams();
  const dispatch = useDispatch();
  const [editNote, setEditNote] = useState(false);
  const [editNoteData, setEditNoteData] = useState(null);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const role_type = useSelector((store) => store?.userSubscription?.role_type);
  const navigate = useNavigate();
  const email = useSelector((store)=> store?.profileDetails?.email);

  function getPlan(role_type) {
    if (role_type === "pro") return "LearnTube Pro User";
    else if (role_type === "pro_plus") return "LearnTube Pro+ User";
    else if (role_type === "x") return "LearnTubeX User";
    else if (role_type === "max") return "LearnTube Max User";

    return "Power Learner";
  }
  const editor = useEditor({
    extensions: [
      StarterKit,
      Heading.configure({
        HTMLAttributes: {
          class: "tiptap-heading",
        },
      }),
      BulletList.configure({
        HTMLAttributes: {
          class: "tiptap-bulletList",
        },
      }),
      OrderedList.configure({
        HTMLAttributes: {
          class: "tiptap-orderedList",
        },
      }),
      Blockquote.configure({
        HTMLAttributes: {
          class: "tiptap-blockquote",
        },
      }),
      Placeholder.configure({
        placeholder: "Write your notes here…",
      }),
    ],
    // content: { "type": "doc", "content": [{ "type": "paragraph", "content": [{ "type": "text", "text": "Create Notes at 00:00asa" }] }, { "type": "paragraph", "content": [{ "type": "text", "text": "asas" }] }, { "type": "paragraph", "content": [{ "type": "text", "text": "as" }] }] },
  });

  const addToHashmap = (key, value) => {
    setHashmap((prevState) => ({
      ...prevState,
      [key]: value, // Add or update the value associated with the key
    }));
  };
  console.log("lesson_id", lesson_id, deleteModal);
  useEffect(() => {
    user_id &&
      dispatch(
        getUserNotes(
          lesson_id,
          (succesObj) => {
            setUserNotes(succesObj?.data);
            let aiNoteData = succesObj?.data?.filter(
              (item) => item?.type === "ai"
            )?.[0];
            // aiNoteData?.notes = aiNoteData?.notes?.replace(/\d+\./g, "");
            //console.log(aiNoteData?.notes);
            if (aiNoteData) {
              let newObj = {
                ...aiNoteData,
                notes: aiNoteData?.notes?.replaceAll("\n", "<br/>"),
              };
              // console.log('newObj' , newObj);
              setUserAiNote(newObj);
              setIsGeneratingNote(null);
              setUserPermission(true);
            }
          },
          (erroObj) => {}
        )
      ) &&
      dispatch(
        getOtherLearnerNotes(
          lesson_id,
          (succesObj) => {
            if (succesObj?.result === "success") {
              setOtherLearnerNotes(succesObj?.data);
            } else {
              toast.error(succesObj?.message);
            }
          },
          (errorObj) => {}
        )
      );
    return () => {
      setUserNotes(null);
      setUserAiNote(null);
      setIsGeneratingNote(false);
      setUserPermission(false);
      setUserSelectedNote({ type: "custom" });
      setIsEditUserNote(false);
      setIsPublicNote(true);
      setOtherLearnerNotes([]);
      setNonEditableNote({});
      setOpenNonEditableModal(false);
      setDeleteModal({ is_open: false, note: null });
      setHashmap({});
    };
  }, [lesson_id]);

  function editNoteHandler(note) {
    editor?.commands?.clearContent(true);
    if (note?.type === "ai") setIsEditAiNote(true);
    else setIsEditUserNote(true);
    editor?.commands?.setContent(note?.notes);
  }

  function likeLearnerNoteHandler(otherNote) {
    dispatch(
      likeUserNote(
        otherNote?.id,
        (succesObj) => {
          if (succesObj?.result === "success") {
            const newArray = otherLearnerNotes?.map((item) => {
              if (item?.id === otherNote?.id) {
                if (succesObj?.message === "Added like.")
                  return {
                    ...item,
                    like_count: item?.like_count + 1,
                    is_liked: !item?.is_liked,
                  };
                else
                  return {
                    ...item,
                    like_count: item?.like_count - 1,
                    is_liked: !item?.is_liked,
                  };
              }
              return item;
            });

            setOtherLearnerNotes(newArray);
          } else {
            toast.error(succesObj?.message);
          }
        },
        (erroObj) => {}
      )
    );
  }

  function saveNoteHandler(note, note_id, noteHtml, visibility, language) {
    if (note_id) {
      dispatch(
        EditUserNote(note_id, noteHtml, visibility, language, (succesObj) => {
          if (succesObj?.result === "success") {
            if (note?.type === "ai") {
              setIsEditAiNote(false);
              setUserAiNote((prev) => ({ ...prev, notes: editor?.getHTML() }));
            } else {
              setIsEditUserNote(false);

              const newArray = userNotes?.map((item) => {
                if (item?.id === note?.id) {
                  return { ...item, notes: noteHtml };
                }
                return item;
              });
              console.log("test", note?.id, newArray, noteHtml);
              setUserNotes(newArray);
            }

            editor?.commands?.clearContent(true);
            isPublicNote(true);
          } else {
            toast.error(succesObj?.message);
          }
        }),
        (erroObj) => {}
      );
    } else {
      dispatch(
        createUserNote(
          lesson_id,
          language,
          noteHtml,
          isPublicNote === true ? "public" : "private",
          (succesObj) => {
            if (succesObj?.result === "success") {
              const newArray = userNotes;
              newArray.push(succesObj?.data);
              setUserNotes(newArray);

              setIsPublicNote(true);
              setIsEditUserNote(false);

              editor?.commands?.clearContent(true);
            } else {
              toast.error(succesObj?.message);
            }
          }
        ),
        (erroObj) => {}
      );
    }
  }
  function resetNoteHandler(note) {
    dispatch(
      resetUserAiNote(
        note?.id,
        (successObj) => {
          if (successObj?.result === "success") {
            let newObj = {
              ...successObj?.data,
              notes: successObj?.data?.notes?.replaceAll("\n", "<br/>"),
            };
            console.log("newObj", newObj);
            setUserAiNote(newObj);
            editor?.commands?.clearContent(true);
          } else {
            toast.error(successObj?.message);
          }
        },
        (errorObj) => {}
      )
    );
  }

  function deleteHandler(note) {
    dispatch(
      deleteUserNote(
        note?.id,
        (successObj) => {
          if (successObj?.result === "success") {
            const newArray = userNotes?.filter((item) => item?.id !== note?.id);
            setUserNotes(newArray);
            setDeleteModal((prev) => ({ ...prev, is_open: false }));
          } else {
            toast.error(successObj?.message);
          }
        },
        (errorObj) => {}
      )
    );
  }

  async function linkedinNotesAuth(note) {
    try {
      Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARE_CLICKED, {
        distinct_id: email,
      });
      dispatch(
        editRedirectType({
          type: "linkedin_content_player_notes",
          id: note?.id,
        })
      );
      dispatch(
        editLastVisitedContent(
          `/${course_slug}/${skill_slug}/${mskill_slug}/${contentId}`
        )
      );
      // dispatch(editLastUnlockedCertificateImage(sampleMskillCertificateLink))

      const client_id = "869nptcg5u1iwx";
      // console.log(client_id)
      const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=${LINKEDIN_REDIRECT_URI}&response_type=code&scope=w_member_social profile openid email`;
      window.location.href = url;
      return { success: true };
    } catch (err) {
      console.log(err);
      return { success: false };
    }
  }

  async function linkedinLearningsAuth(note) {
    try {
      Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARE_CLICKED, {
        distinct_id: email,
      });
      dispatch(
        editRedirectType({
          type: "linkedin_content_player_learnings",
          id: lesson_id,
        })
      );
      dispatch(
        editLastVisitedContent(
          `/${course_slug}/${skill_slug}/${mskill_slug}/${contentId}`
        )
      );
      // dispatch(editLastUnlockedCertificateImage(sampleMskillCertificateLink))

      const client_id = "869nptcg5u1iwx";
      // console.log(client_id)
      const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=${LINKEDIN_REDIRECT_URI}&response_type=code&scope=w_member_social profile openid email`;
      window.location.href = url;
      return { success: true };
    } catch (err) {
      console.log(err);
      return { success: false };
    }
  }

  if (userNotes || !user_id) {
    return (
      <div className="my-4 flex w-full flex-col">
        {/* start of user ai notes */}
        <div
          className={`notes-parent-shadow  mt-0 flex w-full flex-col items-center justify-center rounded-xl border-2`}
        >
          <div className="flex w-full items-center justify-between border-b-2 p-2 md:p-3 ">
            <h1 className="text-[20px] font-semibold md:text-[28px]">
              AI Notes
            </h1>
            <div
              className={`box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Content_player/Group%209043.svg?updatedAt=1693982363150"
                className=""
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              <p
                className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center font-semibold text-[white]`}
              >
                <span
                  className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                >
                  LearnTube
                </span>
                <span
                  className={` x-font-family mr-2 text-[12px] font-normal uppercase md:text-[18.5px]`}
                >
                  X
                </span>
                <span
                  className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                >
                  {" "}
                  Feature
                </span>
              </p>
            </div>
          </div>
          {isGeneratingNote === null ? (
            userPermission ? (
              isEditAiNote ? (
                <div className="mb-3 w-full">
                  <EditorMenu editor={editor} user_id={user_id} />
                  <div className="h-60 overflow-y-auto text-sm md:max-h-60 md:text-base ">
                    <EditorContent
                      editor={editor}
                      className={"rounded-b-xl p-3"}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex w-full flex-col items-start justify-center p-3 md:p-4">
                  <div
                    className="w-full"
                    dangerouslySetInnerHTML={{ __html: userAiNote?.notes }}
                  />
                  <div className="mt-6 flex w-full items-center justify-between">
                    <button
                      className="flex items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] py-2 px-4"
                      onClick={(e) => {
                        e.stopPropagation();
                        linkedinNotesAuth(userAiNote);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faLinkedin}
                        className="text-[#0077B5]"
                        size="2x"
                      />
                      <span className="text-[14px] font-semibold text-[#0077B5] md:text-[16px]">
                        Share On LinkedIn
                      </span>
                    </button>
                    <div className="flex items-center justify-center gap-4 md:gap-6">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="cursor-pointer rounded-full bg-[#1CA571] p-2 text-white"
                        onClick={(e) => {
                          editNoteHandler(userAiNote);
                        }}
                      />
                      <FontAwesomeIcon
                        icon={faRotateLeft}
                        size="xl"
                        className="cursor-pointer text-[#1CA571]"
                        onClick={(e) => {
                          setUserAiNote({ notes: "Resetting Ai Note...." });
                          resetNoteHandler(userAiNote);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )
            ) : (
              <div className="relative">
                {window.innerWidth > 758 ? (
                  <div className=" text-start flex items-center justify-center py-2 px-2 text-sm opacity-30 blur-sm md:p-6">
                    Define Market Demographics: Understand basic audience
                    characteristics like age, gender, income, occupation, etc.
                    vntie ivtoie viotn roitnr ointr ogi ntro no vrvo tor otvnro
                    vtr otrvmo tmrvom trmv otmr omtr mvtrmv tor nvntnrv
                    <br />
                    <br />
                    Uncover Market Psychographics: Gain insights into your
                    audience's personality, behaviors, attitudes, and
                    preferences.vgrn ivng tvoor toi o vtorng otrm obvotrno vir
                    votnv oitrn ov vmotrmogm trmvom trvm otrmvo tmrvm trom vtor
                    vmtmro vmtr okvtro vmtr vmti rmvito rmvoi trm vmtrov mtormv
                    <br />
                    <br />
                    Develop Audience Persona: Use demographic and psychographic
                    data to create a fictional representation of your target
                    audiencevkgoiv ovtr o kvtrk trk r ktkr kt rgk trk bkr ktrpk
                    prk bkrpk tr mvomrov trm trm trm itrmg otmrgo mtrogm tormg
                    otmrgo mtro mto rmvmogrmvmtrvotn rv to
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                  </div>
                ) : (
                  <div className=" text-start flex items-center justify-center py-2 px-2 text-sm opacity-30 blur-sm">
                    Define Market Demographics: Understand basic audience
                    characteristics like age, gender, income, occupation, etc.
                    <br />
                    <br />
                    Uncover Market Psychographics: Gain insights into your
                    audience's personality, behaviors, attitudes, and
                    preferences.
                    <br />
                    <br />
                    Develop Audience Persona: Use demographic and psychographic
                    data to create a fictional representation of your target
                    audience
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                  </div>
                )}
                <div className="absolute top-2 flex w-full px-2 flex-col items-center justify-center md:top-0 ">
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src="https://assets.learntube.ai/files/Content_player/dizziness%201.gif?updatedAt=1693985316179"
                    className="h-[95px] w-[168px]"
                    transformation={[
                      {
                        height: "160",
                        width: "160",
                      },
                    ]}
                  />
                  <div className="px-4 text-center text-[14px]  font-semibold md:text-[16px]">
                    You’ve<span className="text-[#FF2633]"> Exhausted </span>All
                    Your Notes Generation. Upgrade To LearnTubeX to Enjoy
                    Unlimited Notes Generation!
                  </div>
                  <button
                    className="upgrade-button rounded-xl w-full md:w-[40%] mt-2 flex items-center justify-center px-8 py-2 text-[14px] font-semibold text-white md:mt-6 md:text-[18px]"
                    onClick={(e) => window.open("/pricing", "_blank")}
                  >
                    <img
                      urlEndpoint="https://assets.learntube.ai/files/"
                      src="https://assets.learntube.ai/files/Content_player/Group%209045.svg?updatedAt=1693995597919"
                      className="mr-1 h-[20px] w-[20px]"
                      transformation={[
                        {
                          height: "160",
                          width: "160",
                        },
                      ]}
                    />
                    Upgrade To LearnTubeX
                  </button>
                  <div className="my-2 flex w-full flex-col items-center justify-center  p-1 md:mt-4 md:flex-row md:gap-4 ">
            <button
              className=" flex w-full md:w-[40%] items-center justify-center gap-2 rounded-xl border-2 border-[#0077B5] bg-white py-2 px-4"
              onClick={(e) => {
                e.stopPropagation();
                linkedinLearningsAuth();
              }}
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                className="text-[#0077B5]"
                size="2x"
              />
              <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                Share Learnings On LinkedIn
              </span>
            </button>
          </div>
                </div>
              </div>
            )
          ) : (
            <div className="relative">
              {window.innerWidth > 758 ? (
                <div className=" text-start flex items-center justify-center py-2 px-2 text-sm opacity-30 blur-sm">
                  Define Market Demographics: Understand basic audience
                  characteristics like age, gender, income, occupation, etc.
                  vntie ivtoie viotn roitnr ointr ogi ntro no vrvo tor otvnro
                  vtr otrvmo tmrvom trmv otmr omtr mvtrmv tor nvntnrv
                  <br />
                  <br />
                  Uncover Market Psychographics: Gain insights into your
                  audience's personality, behaviors, attitudes, and
                  preferences.vgrn ivng tvoor toi o vtorng otrm obvotrno vir
                  votnv oitrn ov vmotrmogm trmvom trvm otrmvo tmrvm trom vtor
                  vmtmro vmtr okvtro vmtr vmti rmvito rmvoi trm vmtrov mtormv
                  <br />
                  <br />
                  Develop Audience Persona: Use demographic and psychographic
                  data to create a fictional representation of your target
                  audiencevkgoiv ovtr o kvtrk trk r ktkr kt rgk trk bkr ktrpk
                  prk bkrpk tr mvomrov trm trm trm itrmg otmrgo mtrogm tormg
                  otmrgo mtro mto rmvmogrmvmtrvotn rv to
                </div>
              ) : (
                <div className=" text-start flex items-center justify-center py-2 px-2 text-sm opacity-30 blur-sm">
                  Define Market Demographics: Understand basic audience
                  characteristics like age, gender, income, occupation, etc.
                  <br />
                  <br />
                  Uncover Market Psychographics: Gain insights into your
                  audience's personality, behaviors, attitudes, and preferences.
                  <br />
                  <br />
                  Develop Audience Persona: Use demographic and psychographic
                  data to create a fictional representation of your target
                  audience
                </div>
              )}

              <div className="absolute top-4 flex w-full flex-col items-center justify-center md:top-0">
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={
                    isGeneratingNote
                      ? "https://assets.learntube.ai/files/Ai%20notes/Journalist%20Notes.gif?updatedAt=1713947271189"
                      : "https://assets.learntube.ai/files/Ai%20notes/Notes.gif?updatedAt=1713947270157"
                  }
                  className="h-[136px] w-[136px]"
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                />
                <button
                  className="w-[80%] rounded-xl  bg-[#1CA571]  py-2 text-[14px] font-semibold text-white disabled:opacity-50 md:w-[30%] md:py-3 md:text-[18px]"
                  disabled={isGeneratingNote}
                  onClick={(e) => {
                    if(!user_id)
                      navigate('/login' , {replace : true});
                    else{
                    if (!isGeneratingNote) {
                      setIsGeneratingNote(true);
                      dispatch(
                        generateUserAiNote(
                          lesson_id,
                          "en",
                          (successObj) => {
                            setIsGeneratingNote(null);
                            if (successObj?.result === "success") {
                              setUserPermission(true);
                              let newObj = {
                                ...successObj?.data,
                                notes: successObj?.data?.notes?.replaceAll(
                                  "\n",
                                  "<br/>"
                                ),
                              };
                              console.log("newObj", newObj);
                              setUserAiNote(newObj);
                            } else {
                              setUserPermission(false);
                            }
                          },
                          (erroObj) => {}
                        )
                      );
                    }
                  }
                  }}
                >
                  {isGeneratingNote
                    ? "Generating Notes..."
                    : "Generate Notes For Me"}
                </button>
              </div>
            </div>
          )}
        </div>
        {isGeneratingNote === null && userPermission && isEditAiNote && (
          <div className="my-4 flex w-full justify-end gap-2">
            <button
              className="mr-1 w-[123px] rounded-xl  border-2 border-[#1CA571] py-2 text-[14px] font-semibold text-[#1CA571] md:w-[20%] md:py-3 md:text-[18px]"
              onClick={(e) => {
                setIsEditAiNote(false);
              }}
            >
              Cancel
            </button>
            <button
              className="ml-1 w-[123px] rounded-xl  border-2 border-[#1CA571] bg-[#1CA571] py-2 text-[14px] font-semibold text-white md:w-[20%] md:py-3 md:text-[18px]"
              onClick={(e) => {
                saveNoteHandler(
                  userAiNote,
                  userAiNote?.id,
                  editor.getHTML(),
                  "private",
                  "en"
                );
              }}
            >
              Save Notes
            </button>
          </div>
        )}

        {/* end of user ai notes */}
        {isEditUserNote ? (
          <div>
            <div className="notes-parent-shadow mt-6 rounded-xl border-2">
              <div className="flex w-full items-center justify-between border-b-2 p-2 ">
                <div className="text-[20px] font-semibold md:text-[28px]">
                  New Note
                </div>
              </div>
              <div className="mb-1 w-full ">
                <EditorMenu editor={editor} user_id={user_id} />
                <div className="h-48 overflow-y-auto text-sm md:max-h-60 md:text-base ">
                  <EditorContent
                    editor={editor}
                    className={"rounded-b-xl p-3"}
                  />
                </div>
                <div className="flex items-center justify-start gap-2 p-2">
                  <input
                    type="checkbox"
                    name=""
                    className="note-input h-6  w-6 cursor-pointer rounded-lg border-2 bg-gray-200"
                    checked={isPublicNote}
                    id=""
                    onChange={() => {
                      setIsPublicNote((prev) => !prev);
                    }}
                  />
                  <FontAwesomeIcon icon={faEarthAmericas} />
                  <div className="text-[14px] font-medium">Public Note</div>
                </div>
              </div>
            </div>
            <div className="mt-4 flex w-full justify-end gap-2">
              <button
                className="mr-1 w-[123px] rounded-xl border-2 border-[#1CA571] py-2 text-[14px] font-semibold text-[#1CA571] md:w-[20%] md:py-3 md:text-[18px]"
                onClick={(e) => {
                  setIsEditUserNote(false);
                }}
              >
                Cancel
              </button>
              <button
                className="ml-1 w-[123px] rounded-xl border-2 border-[#1CA571] bg-[#1CA571] py-2 text-[14px] font-semibold  text-white md:w-[20%]  md:py-3 md:text-[18px]"
                onClick={(e) => {
                  saveNoteHandler(
                    userSelectedNote,
                    userSelectedNote?.id,
                    editor.getHTML(),
                    isPublicNote === true ? "public" : "private",
                    "en"
                  );
                }}
              >
                Save Notes
              </button>
            </div>
          </div>
        ) : (
          <div className="flex w-full flex-col justify-center ">
            <button
              className="mt-3 w-[240px] self-center rounded-xl border-2 border-[#1CA571] py-2 text-[16px] font-semibold text-[#1CA571] md:mt-6 md:w-[28%] md:py-3 md:text-[18px]"
              onClick={(e) => {
                if(!user_id)
                  navigate('/login' , {replace : true});
                editor?.commands?.clearContent(true);
                setIsEditUserNote(true);
              }}
            >
              +Add New Notes
            </button>
            <div className="mt-8">
              {userNotes?.map((note, index) =>
                note?.type === "custom" ? (
                  <div className="mb-4 rounded-xl border-2 p-2 md:p-3">
                    <div dangerouslySetInnerHTML={{ __html: note?.notes }} />
                    <div className="mt-2 flex w-full items-center justify-between md:mt-4">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="rounded-full bg-[#1CA571] p-2 text-white"
                        onClick={(e) => {
                          setUserSelectedNote(note);
                          editNoteHandler(note);
                        }}
                      />
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        size={window?.innerWidth > 758 ? "lg" : "sm"}
                        className="cursor-pointer text-[#FF2633]"
                        onClick={(e) => {
                          setDeleteModal((prev) => ({
                            ...prev,
                            is_open: true,
                            note: note,
                          }));
                        }}
                      />
                    </div>
                  </div>
                ) : null
              )}
            </div>

            {otherLearnerNotes?.length > 0 ? (
              <div className="my-4 flex w-full flex-col">
                <h1 className="mb-2 text-[20px] font-medium md:text-[28px]">
                  Learner Notes
                </h1>
                <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 ">
                  {otherLearnerNotes?.map((otherNote, index) => (
                    <div
                      className={`flex w-full  p-3 md:p-4 ${
                        !hashmap[otherNote?.id] ? "h-[220px]" : "h-auto"
                      } relative flex-col items-start  justify-center overflow-hidden rounded-xl shadow-lg `}
                      style={{
                        backgroundImage: `url('https://assets.learntube.ai/files/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                        borderRadius: "30px",
                        width: "100%",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                      }}
                    >
                      <div
                        className={`w-full  ${
                          nonEditableNote[otherNote?.id] &&
                          " opacity-50 blur-sm"
                        }`}
                      >
                        <div>
                          <div className="flex w-full items-center justify-start">
                            <div className=" relative mr-2">
                              {otherNote?.user_details?.profile_image?.length >
                              0 ? (
                                <div
                                  className={`${
                                    window.innerWidth > 758
                                      ? "h-[52px] w-[52px]"
                                      : "h-[48px] w-[48px]"
                                  }`}
                                >
                                  {" "}
                                  <img
                                    src={otherNote?.user_details?.profile_image}
                                    alt="profile image"
                                    className="object-fit h-full w-full rounded-full"
                                  ></img>
                                </div>
                              ) : (
                                <FontAwesomeIcon
                                  className="text-slate-600"
                                  icon={faUserCircle}
                                  size={window.innerWidth > 758 ? "3x" : "3x"}
                                />
                              )}
                              {otherNote?.user_details?.user_role !== 1 &&
                                otherNote?.user_details?.user_role !== 7 && (
                                  <img
                                    urlEndpoint="https://assets.learntube.ai/files/"
                                    src={`https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860`}
                                    className="absolute bottom-0 right-0 h-4 w-4 rounded-full"
                                    transformation={[
                                      {
                                        height: "60",
                                        width: "60",
                                      },
                                    ]}
                                  />
                                )}
                            </div>
                            <div className="leading-tight">
                              <div className="text-[16px] font-semibold md:text-[18px]">
                                {otherNote?.user_details?.name?.split(" ")?.[0]}
                              </div>
                              <div className="text-[14px] text-[#A8A6AC] md:text-[16px]">
                                {getPlan(otherNote?.user_details?.role_type)}
                              </div>
                            </div>
                          </div>
                        </div>
                        {otherNote?.notes?.length >= 200 &&
                        !hashmap[otherNote?.id] ? (
                          <div className="my-4">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: otherNote?.notes?.substring(0, 200),
                              }}
                              className="text-[14px]  line-clamp-3 md:line-clamp-2"
                            />
                            <div
                              className="cursor-pointer  text-[14px] font-semibold text-[#1CA571] underline"
                              onClick={(e) => {
                                if (hashmap[otherNote?.id]) {
                                  addToHashmap(otherNote?.id, false);
                                } else {
                                  addToHashmap(otherNote?.id, true);
                                }
                              }}
                            >
                              View More
                            </div>
                          </div>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: otherNote?.notes,
                            }}
                            className="my-4 text-[14px]"
                          />
                        )}
                        <div className="flex w-full items-center justify-between">
                          <div className="flex items-center gap-2">
                            <FontAwesomeIcon
                              icon={faThumbsUp}
                              size="xl"
                              className={`${
                                otherNote?.is_liked
                                  ? "text-[#1CA571]"
                                  : "text-gray-400"
                              }`}
                              onClick={(e) => likeLearnerNoteHandler(otherNote)}
                            />
                            <div className="font-seimbold text-[14px] text-[#666666]">
                              {otherNote?.like_count} Likes
                            </div>
                          </div>
                          <button
                            className="rounded-3xl border-2 border-[#1CA571] p-2 text-[12px] font-semibold text-[#1CA571] md:px-3 md:py-2 md:text-[14px]"
                            onClick={(e) => {
                              if (role_type === "x" || role_type === "max") {
                                editNoteHandler(otherNote);
                              } else {
                                setOpenNonEditableModal(true);
                              }
                            }}
                          >
                            Edit Note
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        )}

        <UpgradeModal
          openNonEditableModal={openNonEditableModal}
          setOpenNonEditableModal={setOpenNonEditableModal}
        />

        {deleteModal?.is_open && (
          <DeleteNoteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deleteHandler={deleteHandler}
          />
        )}
      </div>
    );
  } else {
    return <Spinner />;
  }
}
